import { GetProjectLink, CreateAssets, UploadAssets, UploadVideo, SubtitleVideo } from "../../axios/ApiProvider"
const EDIT_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_EDITOR_URL
export const createNewProject = async (fromValue) => {
    let result = await GetProjectLink();
    if (!result || result.state == 'error') window.toastr.error(result.data.message);
    else if (!!Object.keys(result.data)[0]) window.location.href = `${EDIT_FRONTEND_URL}/${Object.keys(result.data)[0]}?from=${fromValue}`
  }